module.exports = __webpack_public_path__ + "static/img/10.7ad48c9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/3/sp/10.png
// module id = ld/7
// module chunks = 0